import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, BrowserWrapper, WebviewWrapper } from '@elparking/components'
import isFrame from 'commons/js/util/isFrame'
import CurrentStep from './CurrentStep'
import { RentalCarContractMobileProcessWrapper, RentalCarContractProcessMainContainer, RentalCarContractProcessWrapper } from '../../ui/RentalCarContractProcess'
import Logo from 'commons/js/ui/Logo'
import { STEP_1, STEP_2, STEP_3, STEP_4, STEP_PRE_BOOKING } from '../../constants'
import useSteps from 'commons/js/hooks/useSteps'
import Indicator from './Indicator'
import FatalErrorModal from '../../components/FatalErrorModal'
import { isWebview } from '@elparking/utils'
import useOnBrowserBack from 'commons/js/hooks/useOnBrowserBack'
import RentalCarProcessReminder from '../../components/RentalCarProcessReminder/RentalCarProcessReminder'
import UrlParams from 'commons/js/util/UrlTo/UrlParams'
import { getConstant } from 'commons/js/constants'
import BackButton from 'rental-car-contract/js/components/BackButton'
import { sendCloseWebviewEvent } from 'commons/js/services/sendMessage'

const STEPS = [STEP_1, STEP_2, STEP_3, STEP_4]

let onCloseModal = null
const setOnCloseModal = (value) => { onCloseModal = value }

const getParam = (param) => {
    const searchParams = new UrlParams()
    searchParams.loadFromUrl()
    return searchParams.getAll()[param]
}

function RentalCarProcessContainer ({
    user,
    userLoaded,
    requestUser,
    trackEvent,
    contactRentalCar,
    processWrapper: ProcessWrapper,
    onBrowserBack,
    cleanHistory,
    initialStep,
    isPreConfigured,
    ...restProps
}) {
    useEffect(() => {
        !userLoaded && requestUser()
    }, [userLoaded, requestUser])
    const { currentStep, lastStep, goToStep, goToNextStep, goToPrevStep } = useSteps({ steps: STEPS, initialStep })
    const frame = isFrame()
    const share = getParam('share')

    useOnBrowserBack(() => {
        if (onCloseModal) {
            onCloseModal()
            setOnCloseModal(null)
            return
        }
        goToPrevStep()
    })

    return (<>
        <RentalCarContractProcessMainContainer>
            <header role='banner' aria-label='Pasos del proceso'>
                <BrowserWrapper>
                    {currentStep !== STEP_1 && <Box display={frame ? 'none' : 'block'}>
                        <ProcessWrapper>
                            <Flex as='a' width='100%' justifyContent={['center', 'flex-start']} m='1em 0' href={getConstant('FIREBASE_WEB_LINK_MUTUAMAS')}>
                                <Logo height='32px' />
                            </Flex>
                        </ProcessWrapper>
                        </Box>}
                </BrowserWrapper>
                {currentStep !== STEP_1 && !isPreConfigured && <Indicator
                  currentStep={currentStep}
                  goToStep={goToStep}
                  trackEvent={trackEvent}
                  goToPrevStep={goToPrevStep}
            />}
                {currentStep !== STEP_1 && isPreConfigured && <WebviewWrapper>
                    <BackButton onClick={sendCloseWebviewEvent} />
                    </WebviewWrapper>
                }
            </header>
            <main role='main' aria-label='Selección de vehículos'>
                <ProcessWrapper>
                    <CurrentStep
                      offeredParkingPass={null}
                      step={currentStep}
                      lastStep={lastStep}
                      setOnCloseModal={setOnCloseModal}
                      goToNextStep={goToNextStep}
                      navigate={() => { }}
                      contactRentalCar={contactRentalCar}
                      goToStep={goToStep}
                      share={share}
                      goToPrevStep={goToPrevStep}
                      {...restProps} />
                </ProcessWrapper>
                <RentalCarProcessReminder step={currentStep}/>
            </main>
        </RentalCarContractProcessMainContainer>
        <FatalErrorModal onBack={() => goToStep(STEP_1)} />

    </>)
}

RentalCarProcessContainer.propTypes = {
    user: PropTypes.object,
    requestUser: PropTypes.func,
    trackEvent: PropTypes.func,
    onBrowserBack: PropTypes.func,
    cleanHistory: PropTypes.func,
    contactRentalCar: PropTypes.func,
    userLoaded: PropTypes.bool,
    processWrapper: PropTypes.any,
    initialStep: PropTypes.any,
    isPreConfigured: PropTypes.bool,
}

RentalCarProcessContainer.defaultProps = {
    processWrapper: isWebview() ? RentalCarContractMobileProcessWrapper : RentalCarContractProcessWrapper,
    initialStep: getParam('unbornId') ? STEP_PRE_BOOKING : STEP_2,
    isPreConfigured: !!getParam('unbornId'),
    trackEvent: () => {},
}

export default RentalCarProcessContainer
